import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { AxiosRequestConfig, AxiosError } from 'axios';
import { instance } from './baseApi';

type AxiosBaseQueryArgs = {
  pathname: string;
  method?: AxiosRequestConfig['method'];
  data?: any;
  params?: Record<string, any>;
  signal?: AbortSignal;
  responseType?: AxiosRequestConfig['responseType'];
};

export const axiosBaseQuery =
  (): BaseQueryFn<AxiosBaseQueryArgs, unknown, unknown> =>
  async ({ pathname, method = 'GET', data, params, responseType }, api) => {
    try {
      const response = await instance({
        url: pathname,
        method,
        data,
        params,
        signal: api.signal,
        responseType,
      });
      return { data: response.data };
    } catch (error) {
      const axiosError = error as AxiosError;
      return {
        error: {
          status: axiosError.response?.status || 'FETCH_ERROR',
          data: axiosError.response?.data || axiosError.message,
        },
      };
    }
  };
